import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import RewardsQuestions from '../../common/RewardsQuestions';
import { OuterContainer } from './DashboardOuterContainerPagesLayout';
import { AccessResource, useHasAccess } from '../../common/hooks/useHasAccess';
import { Notfound } from '../NotFound';

export default function SupportFAQ() {
  const { t } = useTranslation();
  const theme = useTheme();

  const hasFAQPageAccess = useHasAccess(AccessResource.FAQPage);

  if (!hasFAQPageAccess) {
    return <Notfound />;
  }

  return (
    <OuterContainer
      sx={{
        [theme.breakpoints.up('md')]: {
          width: theme.spacing(81.25),
          paddingTop: theme.spacing(4),
        },
      }}
    >
      <>
        <Typography
          variant="h12"
          sx={{ marginBottom: theme.spacing(3.625) }}
        >
          {t('navigation.faq')}
        </Typography>
        <RewardsQuestions noTitle />
      </>
    </OuterContainer>
  );
}
